import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/iconfont/iconfont.css'
import './assets/iconfont1/iconfont.css'
import './assets/css/scss.scss'
import {
  Button,
  Tabbar,
  TabbarItem,
  Icon,
  NavBar,
  Toast,
  List,
  Form,
  Field,
  Checkbox,
  CheckboxGroup,
  Uploader,
  Divider,
  PullRefresh,
  DatetimePicker,
  Popup,
  Picker,
  Badge,
  Loading,
  Switch,
  Col, Row, Empty, ImagePreview, Tab, Tabs, RadioGroup, Radio, Overlay, Image as VanImage, Dialog, NoticeBar
} from 'vant'

Vue.use(Switch)
Vue.use(Button)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Icon)
Vue.use(NavBar)
Vue.use(Toast)
Vue.use(List)
Vue.use(Form)
Vue.use(Field)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Uploader)
Vue.use(Divider)
Vue.use(PullRefresh)
Vue.use(DatetimePicker)
Vue.use(Popup)
Vue.use(Picker)
Vue.use(Badge)
Vue.use(Loading)
Vue.use(Col)
Vue.use(Row)
Vue.use(Empty)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(ImagePreview)
Vue.use(Overlay)
Vue.use(VanImage)
Vue.use(Dialog)
Vue.use(NoticeBar)
Vue.config.productionTip = false

Vue.prototype.font_size = function () {
  var deviceWidth = document.documentElement.clientWidth || document.body.clientWidth
  if (deviceWidth <= 320) {
    deviceWidth = 320
  }

  if (deviceWidth <= 750) {
    deviceWidth = 750
  }

  if (deviceWidth <= 1366) {
    deviceWidth = 1366
  }

  if (deviceWidth >= 1920) {
    deviceWidth = 1920
  }
  var fontsize = (deviceWidth / 19.2) + 'px'
  document.getElementsByTagName('html')[0].style.fontSize = fontsize
}

// eslint-disable-next-line no-extend-native
String.prototype.startWith = function (str) {
  const reg = new RegExp('^' + str)
  return reg.test(this)
}

// eslint-disable-next-line no-extend-native
String.prototype.endWith = function (str) {
  const reg = new RegExp(str + '$')
  return reg.test(this)
}
if (process.env.NODE_ENV === 'production') {
  if (window) {
    window.console.log = function () {}
  }
}
new Vue({
  router,
  store,
  created () {
    // 刷新或首次登录不论有没有h5config 都重新获取
    this.$store.dispatch('H5CONFIGACTION', 'force')
  },
  render: h => h(App)
}).$mount('#app')
